/* @ngInject */
export default function ($scope, LayoutService, TrainingModules, toastr, $state, $stateParams, PreferencesService) {
	$scope.courseId = $stateParams.courseId;
	$scope.moduleId = $stateParams.moduleId;
	$scope.loading  = true;

	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	$scope.refresh = () => {
		$scope.loading = true;

		TrainingModules.one($scope.moduleId)
		               .get({
			               include: 'course,versions',
		               })
		               .then((module) => {
			               $scope.module  = module;
			               $scope.loading = false;

			               $scope.updateLayout($scope.module.course.name, $scope.module.title);
		               })
		               .catch((error) => {
			               toastr.clear();
			               toastr.error('There was an error while loading this module, please try again.', 'Error');

			               $state.go('staff.training.management.view', {
				               courseId: $scope.courseId,
			               });

			               $scope.loading = false;
		               });
	};

	$scope.updateLayout = (courseName = 'Loading...', moduleName = 'Loading...') => {
		LayoutService.reset();

		LayoutService.setTitle([
			moduleName,
			courseName,
			'Management',
			'Training',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.training.root',
				             displayName: 'Training',
			             },
			             {
				             route:       'staff.training.management.root',
				             displayName: 'Management',
			             },
			             {
				             route:       `staff.training.management.view({ courseId: "${$scope.courseId}" })`,
				             displayName: courseName,
			             },
			             {
				             route:       `staff.training.management.modules.view({ courseId: "${$scope.courseId}", moduleId: "${$scope.moduleId}" })`,
				             displayName: moduleName,
			             },
		             ]);

		let updateButton = LayoutService.getPageHeader()
		                                .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

		let newButton = LayoutService.getPageHeader()
		                             .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-plus"></i> New Version</button>');

		LayoutService.getPageHeader()
		             .onClicked(updateButton, $scope.refresh);

		LayoutService.getPageHeader()
		             .onClicked(newButton, () => {
			             $state.go('staff.training.management.modules.versions.new', {
				             courseId: $scope.courseId,
				             moduleId: $scope.moduleId,
			             });
		             });
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/training/management/modules/view/controller.js